// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2hC6c","Primary":"Button_Primary__3sy1t","Disabled":"Button_Disabled__3bZIL","Loading":"Button_Loading__2Xpaj","swipe":"Button_swipe__13z0W"};